import { IItemCustomization } from '@faire/web-api--source/indigofair/data/IItemCustomization';

export namespace IComputeExpectedAddToCartAmountRequest {
  export namespace IAddToCartItem {
    /**
     * Return an instance of IAddToCartItem with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IAddToCartItem>): IAddToCartItem =>
      ({
        customizations: [],
        ...(partial ?? {}),
      }) as IAddToCartItem;
  }

  export interface IAddToCartItem {
    /**
     * @protobufOption (.faire.common.tokenType) = PRODUCT_OPTION
     */
    product_option_token: string | undefined;
    /**
     * @protobufOption (.faire.common.tokenType) = PRODUCT_COLLECTION
     */
    product_collection_token: string | undefined;
    quantity: number | undefined;
    customizations: Array<IItemCustomization>;
    includes_tester: boolean | undefined;
  }

  /**
   * Return an instance of IComputeExpectedAddToCartAmountRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IComputeExpectedAddToCartAmountRequest>
  ): IComputeExpectedAddToCartAmountRequest =>
    ({
      add_to_cart_items: [],
      ...(partial ?? {}),
    }) as IComputeExpectedAddToCartAmountRequest;
}

export interface IComputeExpectedAddToCartAmountRequest {
  add_to_cart_items: Array<IComputeExpectedAddToCartAmountRequest.IAddToCartItem>;
}
